import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  inviteMembers: {
    id: 'inviteMembers',
    defaultMessage: 'Invite members',
  },
  loginName: {
    id: 'loginName',
    defaultMessage: 'Enter email address or user login',
  },
  sendInvite: {
    id: 'sendInvite',
    defaultMessage: 'Send invite',
  },
  sendInviteHelper: {
    id: 'sendInviteHelper',
    defaultMessage:
      'Your users will have access to the workspace after they log in',
  },
});

export default { ...globalIntl, ...m };
